import { axios } from '@Api/axiosClient';
import type { DashboardContext } from '@Shared';

export const getDashboardContextApi = async (): Promise<DashboardContext> => {
    const response = await axios.get('api/Navigation/GetDashboardContext');
    return response?.data;
};
